module.exports = Object.prototype.hasOwnProperty;


/*****************
 ** WEBPACK FOOTER
 ** ./lib/hasOwnProperty.js
 ** module id = 7
 ** module chunks = 0
 **/